/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tree_Type_118_TitleInputs */

const en_tree_type_118_title = /** @type {(inputs: Tree_Type_118_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iris`)
};

const ar_tree_type_118_title = /** @type {(inputs: Tree_Type_118_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إيريس`)
};

const de_tree_type_118_title = /** @type {(inputs: Tree_Type_118_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iris`)
};

const es_tree_type_118_title = /** @type {(inputs: Tree_Type_118_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iris`)
};

const fr_tree_type_118_title = /** @type {(inputs: Tree_Type_118_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iris`)
};

const it_tree_type_118_title = /** @type {(inputs: Tree_Type_118_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iris`)
};

const ja_tree_type_118_title = /** @type {(inputs: Tree_Type_118_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイリス`)
};

const ko_tree_type_118_title = /** @type {(inputs: Tree_Type_118_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`붓꽃`)
};

const pt_br_tree_type_118_title = /** @type {(inputs: Tree_Type_118_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Íris`)
};

const ru_tree_type_118_title = /** @type {(inputs: Tree_Type_118_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ирис`)
};

const th_tree_type_118_title = /** @type {(inputs: Tree_Type_118_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไอริส`)
};

const tr_tree_type_118_title = /** @type {(inputs: Tree_Type_118_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Süsen Çiçeği`)
};

const zh_cn_tree_type_118_title = /** @type {(inputs: Tree_Type_118_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`鸢尾花`)
};

const zh_tw_tree_type_118_title = /** @type {(inputs: Tree_Type_118_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`鳶尾花`)
};

/**
* | output |
* | --- |
* | "Iris" |
*
* @param {Tree_Type_118_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const tree_type_118_title = /** @type {((inputs?: Tree_Type_118_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tree_Type_118_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tree_type_118_title(inputs)
	if (locale === "ar") return ar_tree_type_118_title(inputs)
	if (locale === "de") return de_tree_type_118_title(inputs)
	if (locale === "es") return es_tree_type_118_title(inputs)
	if (locale === "fr") return fr_tree_type_118_title(inputs)
	if (locale === "it") return it_tree_type_118_title(inputs)
	if (locale === "ja") return ja_tree_type_118_title(inputs)
	if (locale === "ko") return ko_tree_type_118_title(inputs)
	if (locale === "pt_br") return pt_br_tree_type_118_title(inputs)
	if (locale === "ru") return ru_tree_type_118_title(inputs)
	if (locale === "th") return th_tree_type_118_title(inputs)
	if (locale === "tr") return tr_tree_type_118_title(inputs)
	if (locale === "zh_cn") return zh_cn_tree_type_118_title(inputs)
	return zh_tw_tree_type_118_title(inputs)
});